<template>
  <article class="ut-viaje-detalle" tabindex="-1" aria-label="Datos del cierre de viaje">
    <header class="ut-viaje-cabecera">
      <div><span>Cierre</span><h2>{{ modelo.numero }}</h2></div>
      <div><span>Viaje</span><strong>{{ modelo.viaje }}</strong></div>
      <div><span>Fecha</span><strong>{{ modelo.fecha }}</strong></div>
    </header>
    <dl class="ut-viaje-datos"><div v-for="campo in modelo.campos" :key="campo.titulo"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div></dl>
    <section class="ut-viaje-importes">
      <h3>Datos del cierre</h3>
      <dl><div v-for="importe in modelo.importes" :key="importe.titulo"><dt>{{ importe.titulo }}</dt><dd>{{ importe.valor }}</dd></div></dl>
      <div class="ut-viaje-total"><span>Total despues de deducciones</span><strong>{{ modelo.totalCierre }}</strong></div>
    </section>
    <section class="ut-viaje-boletos">
      <h3>Boletos del cierre <span>({{ modelo.totalBoletos }})</span></h3>
      <table>
        <caption class="ut-viaje-sr">Boletos asociados al cierre {{ modelo.numero }}</caption>
        <thead><tr><th scope="col">No. boleto</th><th scope="col">Ruta</th><th scope="col">Importe</th></tr></thead>
        <tbody><tr v-for="boleto in modelo.boletos" :key="boleto.numero"><td>{{ boleto.numero }}</td><td>{{ boleto.ruta }}</td><td>{{ boleto.importe }}</td></tr>
          <tr v-if="!modelo.boletos.length"><td colspan="3" class="ut-viaje-vacio">{{ modelo.disponibles ? 'No hay boletos asociados a este cierre.' : 'No hay datos de boletos disponibles.' }}</td></tr></tbody>
      </table>
      <footer>
        <div class="ut-viaje-total-boletos"><span>Total de boletos</span><strong>{{ modelo.importeBoletos }}</strong></div>
        <nav aria-label="Paginas de boletos" class="ut-viaje-paginas">
          <v-btn icon :disabled="disabled || modelo.pagina <= 1" title="Boletos anteriores" aria-label="Boletos anteriores" @click="$emit('pagina', modelo.pagina - 1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
          <span>Pagina {{ modelo.pagina }} / {{ modelo.paginas }}</span>
          <v-btn icon :disabled="disabled || modelo.pagina >= modelo.paginas" title="Boletos siguientes" aria-label="Boletos siguientes" @click="$emit('pagina', modelo.pagina + 1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </nav>
      </footer>
    </section>
  </article>
</template>

<script>
import { detalleCierreViaje } from './detalleCierreViaje';
export default {
  name: 'DetalleCierreViaje', props: { datos: { type: Object, required: true }, disabled: Boolean },
  computed: { modelo() { return detalleCierreViaje(this.datos); } },
  mounted() { this.$el.focus({ preventScroll: true }); },
};
</script>

<style scoped>
.ut-viaje-detalle { background: #fff; color: #253747; font-size: 13px; line-height: 1.4; letter-spacing: 0; outline: none; }
.ut-viaje-detalle * { box-sizing: border-box; letter-spacing: 0; }
.ut-viaje-detalle dl, .ut-viaje-detalle dd, .ut-viaje-detalle h2, .ut-viaje-detalle h3 { margin: 0; }
.ut-viaje-cabecera { display: grid; grid-template-columns: 1fr 1.6fr 1fr; gap: 16px; padding: 16px 20px; background: #eaf2f8; border-bottom: 1px solid #cfdee9; }
.ut-viaje-cabecera span, .ut-viaje-detalle dt { display: block; font-size: 12px; color: #4a6070; }
.ut-viaje-cabecera h2 { font-size: 23px; line-height: 1.3; }
.ut-viaje-cabecera strong { display: block; margin-top: 4px; font-size: 16px; }
.ut-viaje-detalle .ut-viaje-datos { padding: 16px 20px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px 20px; }
.ut-viaje-detalle dd { margin-top: 3px; font-weight: 600; }
.ut-viaje-importes { background: #f5f7f8; padding: 14px 20px; border-top: 1px solid #d5dce1; border-bottom: 1px solid #d5dce1; }
.ut-viaje-detalle h3 { font-size: 14px; line-height: 1.4; }
.ut-viaje-importes dl { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px 16px; margin-top: 12px; }
.ut-viaje-importes dd { font-variant-numeric: tabular-nums; }
.ut-viaje-total { border-top: 1px solid #d5dce1; margin-top: 14px; padding-top: 10px; display: flex; align-items: baseline; justify-content: space-between; gap: 8px; flex-wrap: wrap; }
.ut-viaje-total strong { font-size: 21px; font-variant-numeric: tabular-nums; }
.ut-viaje-boletos { padding: 16px 20px; }
.ut-viaje-boletos h3 span { font-weight: 400; }
.ut-viaje-boletos table { width: 100%; border-collapse: collapse; table-layout: fixed; margin-top: 12px; }
.ut-viaje-boletos th, .ut-viaje-boletos td { padding: 9px 8px; border-bottom: 1px solid #dce3e8; text-align: left; }
.ut-viaje-boletos th { background: #eaf2f8; color: #304f67; font-size: 12px; }
.ut-viaje-boletos th:first-child { width: 19%; }
.ut-viaje-boletos th:last-child { width: 25%; }
.ut-viaje-boletos td:last-child, .ut-viaje-boletos th:last-child { text-align: right; font-variant-numeric: tabular-nums; }
.ut-viaje-boletos .ut-viaje-vacio { text-align: center; color: #526575; padding: 28px 10px; }
.ut-viaje-boletos footer { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px; margin-top: 14px; }
.ut-viaje-total-boletos span { display: block; font-size: 12px; color: #4a6070; }
.ut-viaje-total-boletos strong { font-variant-numeric: tabular-nums; }
.ut-viaje-paginas { display: flex; gap: 4px; align-items: center; }
.ut-viaje-paginas span { min-width: 100px; text-align: center; font-size: 12px; }
.ut-viaje-detalle dd, .ut-viaje-detalle strong, .ut-viaje-detalle h2, .ut-viaje-detalle td { overflow-wrap: anywhere; }
.ut-viaje-sr { position: absolute; width: 1px; height: 1px; padding: 0; overflow: hidden; clip: rect(0,0,0,0); }
@media (max-width: 600px) {
  .ut-viaje-cabecera { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; padding: 14px 12px; }
  .ut-viaje-cabecera div:nth-child(2) { grid-column: 1 / -1; grid-row: 2; }
  .ut-viaje-detalle .ut-viaje-datos, .ut-viaje-importes dl { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
  .ut-viaje-detalle .ut-viaje-datos, .ut-viaje-importes, .ut-viaje-boletos { padding: 14px 12px; }
  .ut-viaje-boletos table { font-size: 12px; }
  .ut-viaje-boletos th, .ut-viaje-boletos td { padding: 8px 4px; }
  .ut-viaje-boletos th:first-child { width: 25%; }
  .ut-viaje-boletos th:last-child { width: 30%; }
}
</style>
